/**
 * author: Soumya Shreyas
 */
import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Modal, OverlayTrigger } from "react-bootstrap";
import "./RiskScoreMain.scss";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import {
  BiChevronDown,
  BiPlus,
  BiGitMerge,
  BiBorderAll,
  BiPencil,
} from "react-icons/bi";
import "react-bootstrap-typeahead/css/Typeahead.css";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import RiskParameter from "../RiskParameter/RiskParameter";
import AddRiskParameter from "../AddRiskParameter/AddRiskParameter";
import { SCORINGOPTIONS } from "../../../../core/constants/common";
import ScoringMethod from "../ScoringMethod/ScoringMethod";
import RegulationCreate from "../RegulationCreate/RegulationCreate";
import Utils from "../../../../core/utilities/Utils";
import LinkDataSource from "../LinkDataSource/LinkDataSource";
import { RegulationContext } from "../../../../App";
import { useNavigate } from "react-router";
const RiskScoreMain = ({
  t,
  list,
  listType,
  handleChildToggle,
  selectedRegulation,
  parent,
  addRiskParent,
  handleRegEdit,
  configType,
}) => {
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const [riskParams, setRiskParams] = useState([]);
  const [addRiskParameter, setAddRiskParameter] = useState(false);
  const [editRiskParameterId, setEditRiskParameterId] = useState("");
  const [regulationId, setRegulationId] = useState(
    listType === "REGULATION" ? list.id : selectedRegulation
  );
  // const [shown, setShown] = useState(
  //   listType === "REGULATION"
  //     ? selectedRegulation === '' 
  //       ? {}
  //       : { [selectedRegulation]: true }
  //     : { [list.id]: true }
  // );
  // const [shown, setShown] = useState(
  //   listType === "REGULATION"
  //     ? { [selectedRegulation]: true }
  //     : { [list.id]: true }
  // );

  const [shown, setShown] = useState({});
  const [type, setType] = useState(listType);
  const [parentId, setParentId] = useState(parent);
  const [disabled, setDisabled] = useState("disabled");
  const [formulae, setFormulae] = useState(list.formulae ? list.formulae : 0);
  const [isScoring, setIsScoring] = useState(false);
  const [openRegulationSave, setOpenRegulationSave] = useState(false);
  const [editReg, setEditReg] = useState({});
  const [riskConfig, setRiskConfig] = useState([]);
  const [showDataSource, setShowDataSource] = useState(false);
  const { glbRegulations, setGlbRegulations } = useContext(RegulationContext);
  const [selParam, setSelParam] = useState("");
  const [selDsId, setSelDsId] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    console.log('list.idlist.id', list.id)
    setShown(
      listType === "REGULATION"
        ? { [selectedRegulation]: true }
        : { [list.id]: true }
    );
    if (type === "RISK") {
      getRiskParameters();
    } else if (selectedRegulation) {
      getRegulationDetails(selectedRegulation);
    }
  }, [list?.children, configType]);

  useEffect(() => {
    // console.log(',weeeeeeeeeeeeeeeeeeeeeeeeeeeee')
    // handleExpand(selectedRegulation)
    getRegulationDetails(glbRegulation.id);
  }, [glbRegulation]);
  const handleExpand = (id) => {
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });

    newVal === false && setDisabled("disabled");
    newVal === false && setAddRiskParameter(false);
    if (type === "REGULATION") {
      getRegulationDetails(id);
    } else if (type === "RISK") {
      getRiskParameters();
    }
  };
  const getRiskParameters = () => {
    var data = list.children;
    data ? setRiskParams([...data]) : setRiskParams([]);
    data ? setFormulae(list.formulae) : setFormulae("0");
    data && data.length > 1 ? setDisabled("") : setDisabled("disabled");
  };
  const getRegulationDetails = (id) => {
    console.log(list.id, id, list.id === id)
    if (list.id === id) {
      RiskConfigService.getRegulationDetails(id, configType)
        .then((response) => {
          var data = response.data.riskParams;
          if (type === "REGULATION") {
            list.status = response.data.status;
          }
          var riskCateg = response.data.resultConfigs;
          data
            ? setRiskParams([...response.data.riskParams])
            : setRiskParams([]);
          riskCateg ? setRiskConfig(riskCateg) : setRiskConfig([]);
        })
        .catch((error) => {
        });
    }
  };
  const handleRiskDiscard = (isDiscard) => {
    setAddRiskParameter(!isDiscard);
  };
  const handleRiskEdit = (paramId) => {
    setEditRiskParameterId(paramId);
    setAddRiskParameter(true);
  };
  const handleAfterSave = (id) => {
    if (id) {
      handleChildExpand(id);
    } else {
      list.status = "DRAFT";
      type === "REGULATION" && getRegulationDetails(regulationId);
    }
  };
  const handleChildExpand = (id, dataSource = false) => {
    var data = {
      paramId: id,
      regulationId: regulationId,
      childStatus: "Expand",
      type: "RISK",
      configType: configType,
    };
    dataSource && setShowDataSource(true);
    handleChildToggle(data);
  };
  const handleCloseChild = (id) => {
    var data = {
      paramId: id,
      regulationId: regulationId,
      childStatus: "Close",
      type: "RISK",
      parent: parentId,
      configType: configType,
    };
    handleChildToggle(data);
  };
  const changeScoring = (e) => {
    setFormulae(e.target.value);
    setIsScoring(true);
  };
  const handlePublish = (regId) => {
    RiskConfigService.publishRegulation(regId)
      .then((response) => {
        if (response.status === 200) {
          getRegulationDetails(regId);
          setGlbRegulations(response.data);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        // toast.error(error.response.data.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const updateRegulation = (params, regId) => {
    RiskConfigService.updateRegulation(params, regId)
      .then((response) => {
        if (response.status === 200) {
          setGlbRegulations(response.data);
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getRegulationDetails(regId);
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        // toast.error(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  };
  const handleShow = () => {
    setIsScoring(true);
  };
  const handleScoring = (val) => {
    setIsScoring(val);
  };
  const editRegulation = (regId) => {
    setOpenRegulationSave(true);
    // getRegulationDetails (regId);
    setEditReg(list);
    //console.log(editReg);
  };
  const editRegulationCallback = (val, regId) => {
    regId && getRegulationDetails(regId);
    setOpenRegulationSave(val);
  };
  const handleRiskDelete = (obj) => {
    RiskConfigService.deleteRiskParameter(regulationId, obj.id)
      .then((response) => {
        if (response.status === 204) {
          if (obj?.parent?.id) {
            handleChildExpand(obj?.parent?.id);
          } else {
            type === "REGULATION" && getRegulationDetails(regulationId);
          }
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => { });
  };

  const handleDataSourceCallback = (val) => {
    setShowDataSource(false);
    if (val) {
      type === "REGULATION"
        ? getRegulationDetails(regulationId)
        : handleChildExpand(addRiskParent);
    }
  };
  const handleDatasourceLink = (action, riskId, dsId = "") => {
    if (action === "link") {
      setSelParam(riskId);
      setSelDsId(dsId);
      setShowDataSource(true);
    } else if (action === "unlink") {
      RiskConfigService.unlinkDatasource(regulationId, riskId)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            type === "REGULATION"
              ? getRegulationDetails(regulationId)
              : handleChildExpand(riskId);
          }
        })
        .catch((error) => { });
    }
  };

  return (
    <>
      <div className="Topics_headeView">
        <ul>
          <li>
            Risk : <b>{glbRegulation.name}</b>
            {type === "REGULATION" ? (
              <div className="px-1 text-end">
              
                {list.status === "DRAFT" && (
                  <div className="btn-custom p-0 text-end">
                    <button
                      className="btn btn-primary "
                      onClick={(e) => handlePublish(list.id)}
                    >
                      {t("Publish.label")}
                    </button>
                  </div>
                )}
              </div>
            ) : type === "RISK" ? (
              <div className="btn-custom p-1 text-end">
                <button
                  className="btn btn-secondary"
                  onClick={() => handleCloseChild(list.id)}
                >
                  {t("Back.label")}
                </button>
              </div>
            ) : (
              ""
            )
            }
          </li>
          <li>
            {t("ReportingFrequency.label")} : <b>{t(glbRegulation.frequency + ".label")}</b>
          </li>
          <li>
            {t("LastModified.label")} : <b> {moment(glbRegulation.lastModifiedDate).format(
              "MMM DD, YYYY"
            )}</b>
          </li>

          {type === "RISK" && <>

            <li>
              {t("RiskParameter.label")} : <b>{list.name}</b>
            </li>
          </>}
          {type === "RISK" && <>
            <li>
              {t("ScoreingMethod.label")} : 
              <h6 className="mb-0 ms-2">
                <select
                  className="form-select"
                  name="scoring"
                  disabled={disabled}
                  defaultValue={formulae}
                  onChange={(e) => changeScoring(e)}>
                  <option value="0" disabled hidden>
                    {t("Select.label")}
                  </option>
                  {SCORINGOPTIONS.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </h6>
              &nbsp;
              <OverlayTrigger
                placement="top"
                overlay={Utils.renderTooltip(
                  t("ScoringFormula.label")
                )}>
                <span>
                  <BiBorderAll onClick={handleShow} />
                </span>
              </OverlayTrigger>
            </li>
          </>}
        </ul>

      </div>
      {showDataSource ? (
        <LinkDataSource
          regulation={regulationId}
          paramId={selParam}
          dsId={selDsId}
          handleDataSourceCallback={handleDataSourceCallback}
          configType={configType}
        />
      ) : (
        <div
          className="Risk_configuration_card"
          id={list.id}
          key={list.id}
        >
          <div className="card-body p-0">
            <div className="">
              {/* <div className="expand_RswBox 12">
                <BiChevronDown
                  onClick={(e) => handleExpand(list.id)}
                  aria-controls="example-collapse-text"
                  aria-expanded={shown[list.id]}
                ></BiChevronDown>
              </div> */}
              {/* {type === "REGULATION" ? (
                  <div className="col-lg-8 p-1">
                    <div className="row m-0 RSW_Add_Card_head">
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            <h6 className="mb-0 me-2">{list.name}</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("ReportingFrequency.label")}
                            <h6 className="mb-0 ms-2">
                              {t(list.frequency + ".label")}
                            </h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            {t("LastModified.label")}{" "}
                            <h6 className="mb-0 ms-2">
                              {moment(list.lastModifiedDate).format(
                                "MMM DD, YYYY"
                              )}
                            </h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-8 p-1">
                    <div className="row m-0 RSW_Add_Card_head">
                      <div className="col-lg-4 p-0">
                        <ul>
                          <li>
                            <h6 className="mb-0 me-2">{list.name}</h6>
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-3 p-0">
                        <ul
                          className="cursor"
                          onClick={() => handleChildExpand(list.id)}
                        >
                          <li>
                            <h6 className="mb-0 ms-2">
                              {list.children ? list.childrenCount : 0}
                            </h6>
                          </li>
                          <li>
                            <BiGitMerge />
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-5 p-0">
                        <ul>
                          <li>
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("ScoringFormula.label")
                              )}
                            >
                              <span>{t("ScoreingMethod.label")} </span>
                            </OverlayTrigger>
                            <h6 className="mb-0 ms-2">
                              <select
                                className="form-select"
                                name="scoring"
                                disabled={disabled}
                                defaultValue={formulae}
                                onChange={(e) => changeScoring(e)}
                              >
                                <option value="0" disabled hidden>
                                  {t("Select.label")}
                                </option>
                                {SCORINGOPTIONS.map(({ value, label }) => (
                                  <option key={value} value={value}>
                                    {label}
                                  </option>
                                ))}
                              </select>
                            </h6>
                            &nbsp;
                            <OverlayTrigger
                              placement="top"
                              overlay={Utils.renderTooltip(
                                t("ScoringFormula.label")
                              )}
                            >
                              <span>
                                <BiBorderAll onClick={handleShow} />
                              </span>
                            </OverlayTrigger>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )} */}


              {/* {console.log(shown)} */}
              {/* {console.log(Object.keys(shown).length)}
                {Object.keys(shown).length === 0 ? "HI" :"HELLO" } */}
              {riskConfig.length > 0 && (
                <div className="Risk_config_data">
                  <div className="row mx-0 ">
                    <div className="col-lg-3 p-2">
                      {t("RiskCategories.label")}
                    </div>
                    {riskConfig?.map((categ) => (
                      <div className="col-lg-3 p-2" key={categ.id}>
                        <ul>
                          <li>
                            <span style={{ color: categ.colorCode }}>
                              {categ.resultType}
                            </span>
                          </li>
                          <li>
                            <h6 className="mb-0">
                              {categ.minScore}-{categ.maxScore}
                            </h6>
                          </li>
                        </ul>
                      </div>
                    ))}
                  </div>
                  <div className="Edit_iconbox">
                    <OverlayTrigger
                      placement="top"
                      overlay={Utils.renderTooltip(
                        t("EditCompliance.label")
                      )}
                    >
                      <button
                        className="btn btn-blank_outline"
                        onClick={() => editRegulation(list.id)}
                      >
                        <BiPencil />
                      </button>
                    </OverlayTrigger>
                  </div>
                </div>
              )}
              {riskParams.length > 0 ? (
                <RiskParameter
                  riskParams={riskParams}
                  handleEdit={handleRiskEdit}
                  handleChild={handleChildExpand}
                  handleDelete={handleRiskDelete}
                  handleDatasourceLink={handleDatasourceLink}
                />
              ) : (
                <div>{t("NoRulesConfigured.label")}</div>
              )}

              <div className="col-lg-12 p-1" id="idRiskParameter">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setAddRiskParameter(true);
                    setEditRiskParameterId("");
                    setShown({
                      ...shown,
                      [list.id]: true,
                    });
                  }}
                >
                  <BiPlus className="me-2"> </BiPlus>
                  {t("RiskParameter.label")}
                </button>
              </div>
              {/* <Collapse in={shown[list.id]}>
                  <div className="col-lg-12 p-1">
                    {riskConfig.length > 0 && (
                      <div className="row m-0">
                        <div className="col-lg-3 p-2">
                          {t("RiskCategories.label")}
                        </div>
                        {riskConfig?.map((categ) => (
                          <div className="col-lg-3 p-2" key={categ.id}>
                            <ul>
                              <li>
                                <span style={{ color: categ.colorCode }}>
                                  {categ.resultType}
                                </span>
                              </li>
                              <li>
                                <h6 className="mb-0">
                                  {categ.minScore}-{categ.maxScore}
                                </h6>
                              </li>
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                    {riskParams.length > 0 ? (
                      <RiskParameter
                        riskParams={riskParams}
                        handleEdit={handleRiskEdit}
                        handleChild={handleChildExpand}
                        handleDelete={handleRiskDelete}
                        handleDatasourceLink={handleDatasourceLink}
                      />
                    ) : (
                      <div>{t("NoRulesConfigured.label")}</div>
                    )}

                    <div className="col-lg-12 p-1" id="idRiskParameter">
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setAddRiskParameter(true);
                          setEditRiskParameterId("");
                          setShown({
                            ...shown,
                            [list.id]: true,
                          });
                        }}
                      >
                        <BiPlus className="me-2"> </BiPlus>
                        {t("RiskParameter.label")}
                      </button>
                    </div>
                  </div>
                </Collapse> */}
              {/* {addRiskParameter && (
                <AddRiskParameter
                  regulation={regulationId}
                  handleDiscard={handleRiskDiscard}
                  editRiskId={editRiskParameterId}
                  handleSave={handleAfterSave}
                  type={type}
                  addRiskParent={addRiskParent}
                  configType={configType}
                />
              )} */}
            </div>
          </div>
        </div>
      )}

      {isScoring && (
        <ScoringMethod
          formulaeType={formulae}
          riskParams={riskParams}
          regulation={regulationId}
          paramId={addRiskParent}
          handleScoring={handleScoring}
          list={list}
        />
      )}

      {openRegulationSave && (
        <RegulationCreate
          handleCreateReg={editRegulationCallback}
          editReg={editReg}
          configType={configType}
        />
      )}
      <Modal show={addRiskParameter} onHide={handleRiskDiscard}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
      >
        <Modal.Header>
          < Modal.Title as="h5">
            {editRiskParameterId ? <span>Edit </span> : <span>Add </span>}
            risk parameter</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <AddRiskParameter
            regulation={regulationId}
            handleDiscard={handleRiskDiscard}
            editRiskId={editRiskParameterId}
            handleSave={handleAfterSave}
            type={type}
            addRiskParent={addRiskParent}
            configType={configType}
          />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Understood</Button>
        </Modal.Footer> */}

      </Modal>
    </>
  );
};
RiskScoreMain.propTypes = {};
export default withTranslation()(RiskScoreMain);
